import { TEXT_FILE_PREVIEW_MAX_SIZE_BYTES } from './text-file-preview'

export const HTML_FILE_PREVIEW_MIME_TYPE = 'text/html'
export const HTML_FILE_PREVIEW_MAX_SIZE_BYTES = TEXT_FILE_PREVIEW_MAX_SIZE_BYTES

const HTML_PREVIEW_CONTENT_SECURITY_POLICY = [
  "default-src 'none'",
  "base-uri 'none'",
  "object-src 'none'",
  "script-src 'unsafe-inline'",
  "style-src 'unsafe-inline'",
  'img-src data: blob:',
  'font-src data:',
  'media-src data: blob:',
  "connect-src 'none'",
  "frame-src 'none'",
  "child-src 'none'",
  "worker-src 'none'",
  "form-action 'none'",
  "manifest-src 'none'"
].join('; ')
const HTML_PREVIEW_SECURITY_PREFIX = `<!doctype html><meta http-equiv="Content-Security-Policy" content="${HTML_PREVIEW_CONTENT_SECURITY_POLICY}"><meta name="referrer" content="no-referrer">`

/**
 * Adds the same restricted document headers used by the HTML file preview.
 * @param {string} content HTML document content.
 * @returns {string} Sandboxed HTML document content.
 */
export function createSafeHtmlPreviewDocument(content: string): string {
  return `${HTML_PREVIEW_SECURITY_PREFIX}${content}`
}

export type HtmlFilePreviewClassification = 'not-html' | 'supported' | 'unsupported'

const GENERIC_MIME_TYPES = new Set(['application/octet-stream', 'binary/octet-stream'])

/**
 * Classifies whether file metadata safely identifies browser-renderable HTML.
 * @param {string | null | undefined} fileName File name or path to inspect.
 * @param {string | null | undefined} mimeType Supplied MIME metadata.
 * @returns {HtmlFilePreviewClassification} HTML preview support state.
 */
export function classifyHtmlFilePreview(
  fileName: string | null | undefined,
  mimeType?: string | null
): HtmlFilePreviewClassification {
  const normalizedName = (fileName ?? '').split(/[?#]/, 1)[0].toLowerCase()

  if (!normalizedName.endsWith('.html')) {
    return 'not-html'
  }

  const normalizedMimeType = (mimeType ?? '').split(';', 1)[0].trim().toLowerCase()

  if (
    normalizedMimeType &&
    !GENERIC_MIME_TYPES.has(normalizedMimeType) &&
    normalizedMimeType !== HTML_FILE_PREVIEW_MIME_TYPE
  ) {
    return 'unsupported'
  }

  return 'supported'
}
